import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { Request } from "src/app/parametrage/core/model/request";
import { CorrespondreDossierEtCoreBanking } from "src/app/parametrage/core/model/request/correspondre-dossier-et-core-banking";

@Component({
  selector: "app-correspondre-dossier-modal",
  templateUrl: "./correspondre-dossier-modal.component.html",
  styleUrls: ["./correspondre-dossier-modal.component.scss"],
})
export class CorrespondreDossierModalComponent implements OnInit {
  @Input() requestId;

  request: Request;

  form2: FormGroup;
  pressButton: Boolean = false;
  correspondence: CorrespondreDossierEtCoreBanking =
    new CorrespondreDossierEtCoreBanking();

  dateReelMisEnPlaceJson: any;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private _requestService: RequestService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      numeroDossierPret: [null, Validators.compose([Validators.required])],
      numDossier: [null, Validators.compose([Validators.required])],
      dateReelMiseEnPlace: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getRequestById(this.requestId);
  }

  getRequestById(id) {
    this._requestService.getRequestById(id).subscribe(
      (data) => {
        this.request = data;
        this.dateReelMisEnPlaceJson = this.convertDateStringToDateJson(
          this.request.dateReelMiseEnPlace
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.spinner.show();
    this.pressButton = true;

    this.correspondence.requestId = this.requestId;
    this.correspondence.numeroDossierPret = this.form2.value.numeroDossierPret;
    this.correspondence.numDossier = this.form2.value.numDossier;
    this.correspondence.dateReelMiseEnPlace =
      this.convertDateJsonToDateString(this.dateReelMisEnPlaceJson, {
        hour: 0,
        minute: 0,
      }) + ":00Z";

    this._requestService
      .saveNumDossierCoreBanking(this.correspondence)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }

  convertDateStringToDateJson(date: string) {
    let dateSimple = new Date(date);
    let dateJson = {
      year: dateSimple.getFullYear(),
      month: dateSimple.getMonth() + 1,
      day: dateSimple.getDate(),
    };
    return dateJson;
  }

  convertDateJsonToDateString(date, time) {
    let month;
    month = date.month;
    if (date.month < 10) {
      month = "0" + date.month;
    }

    let day;
    day = date.day;
    if (date.day < 10) {
      day = "0" + date.day;
    }

    //

    let hour;
    hour = time.hour;
    if (time.hour < 10) {
      hour = "0" + time.hour;
    }

    let minute;
    minute = time.minute;
    if (time.minute < 10) {
      minute = "0" + time.minute;
    }

    let datetime =
      date.year + "-" + month + "-" + day + "T" + hour + ":" + minute;
    return datetime;
  }
}
